import ConfirmationLayout from './ConfirmationLayout';

export default ConfirmationLayout;
